import React from "react";

const NotFound = () => (
    <div>
        <h3>404 page not found</h3>
        <p>
            The page you are looking for does not exist. Check that the URL
            you've entered is correct and try again.
        </p>
    </div>
);

export default NotFound;
